/**
 * <kurzus-vasarlas> — a vásárlógomb és a jogi jelölőnégyzet összekötése.
 *
 * Digitális tartalomnál a vevőnek kifejezetten hozzá kell járulnia az azonnali
 * teljesítéshez, és ezzel elveszíti a 14 napos elállási jogát
 * (45/2014. (II. 26.) Korm. rendelet 29. § (1) m).
 *
 * MI VÁLTOZOTT 2026. AUGUSZTUS 31-ÉN — ÉS MIÉRT
 * A korábbi változat betöltéskor `disabled`-re állította a gombot, és csak a
 * pipa bejelölésekor engedte fel:
 *
 *     this.gomb.disabled = !this.pipa.checked;   // ← ez volt a hiba
 *
 * A vevő ebből annyit látott, hogy a gomb szürke, és nem lehet rákattintani.
 * Semmi nem magyarázta meg, miért. Ez pontosan úgy néz ki, mint egy elromlott
 * oldal — és mivel mindkét vásárló szekció ezt a komponenst használja, sehol
 * nem lehetett vásárolni.
 *
 * Innentől a gomb SOHA nem lesz disabled a hozzájárulás miatt. Mindig
 * kattintható, és mindig van visszajelzés:
 *
 *   pipa nincs bejelölve → a beküldés megáll, magyar hibaüzenet jelenik meg a
 *                          mezőnél, a mező látótérbe görget, és megkapja a fókuszt
 *   pipa be van jelölve  → az űrlap elmegy a /cart/add-ra, onnan a pénztárra
 *
 * A gomb egyetlen esetben marad disabled: ha a termék tényleg elfogyott. Azt a
 * `data-elfogyott` attribútum jelzi, és azt a Liquid teszi rá, nem ez a fájl.
 *
 * JAVASCRIPT NÉLKÜL IS MŰKÖDIK
 * A jelölőnégyzet `required` attribútummal érkezik, tehát ha ez a fájl nem fut
 * le, a böngésző maga akadályozza meg a beküldést. A komponens ezt átveszi:
 * leszedi a `required`-et, hogy ne a böngésző gyakran angol buborékja jöjjön,
 * hanem a szekcióban beállított magyar üzenet.
 *
 * MIÉRT WEB COMPONENT, ÉS NEM DOMContentLoaded
 * A Theme Editor futás közben újrarendereli a szekciókat. Egy egyszeri
 * DOMContentLoaded-listener az újrarenderelt szekcióra már nem futna le, és a
 * szerkesztő előnézetében elromlana a gomb. A customElements minden új
 * példányon lefut, külön shopify:section:load figyelés nélkül.
 */

class KurzusVasarlas extends HTMLElement {
  connectedCallback() {
    this.pipa = this.querySelector('[data-kurzus-hozzajarulas]');
    this.gomb = this.querySelector('[data-kurzus-gomb]');
    this.hiba = this.querySelector('[data-kurzus-hiba]');
    this.urlap = this.querySelector('form');

    if (!this.gomb || !this.urlap) return;

    // Elfogyott terméknél a Liquid tette rá a disabled-et. Nem nyúlunk hozzá.
    if (this.elfogyott) return;

    // A gomb mindig kattintható. Ha egy korábbi állapotból maradt rajta
    // disabled, azt is levesszük.
    this.gomb.disabled = false;
    this.gomb.removeAttribute('disabled');

    if (!this.pipa) return;

    // Innentől mi validálunk, magyarul, a mezőnél — nem a böngésző buborékja.
    this.pipa.removeAttribute('required');

    this.valtozas = this.valtozas.bind(this);
    this.bekuldes = this.bekuldes.bind(this);

    this.pipa.addEventListener('change', this.valtozas);
    this.urlap.addEventListener('submit', this.bekuldes);
  }

  disconnectedCallback() {
    this.pipa?.removeEventListener('change', this.valtozas);
    this.urlap?.removeEventListener('submit', this.bekuldes);
  }

  get elfogyott() {
    return this.gomb.hasAttribute('data-elfogyott');
  }

  bekuldes(esemeny) {
    if (this.pipa.checked) return;

    esemeny.preventDefault();
    this.hibaMutat();

    // A mező kerüljön látótérbe, mielőtt ráugrik a fókusz — különben mobilon a
    // hibaüzenet a képernyőn kívül marad, és megint úgy tűnik, nem történt semmi.
    const nyugalom = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.pipa.scrollIntoView({ behavior: nyugalom ? 'auto' : 'smooth', block: 'center' });
    this.pipa.focus({ preventScroll: true });
  }

  valtozas() {
    if (this.pipa.checked) this.hibaElrejt();
  }

  hibaMutat() {
    if (!this.hiba) return;
    this.hiba.hidden = false;
    this.pipa.setAttribute('aria-invalid', 'true');
    this.pipa.setAttribute('aria-describedby', this.hibaAzonosito());
  }

  hibaElrejt() {
    if (!this.hiba) return;
    this.hiba.hidden = true;
    this.pipa.removeAttribute('aria-invalid');
    this.pipa.removeAttribute('aria-describedby');
  }

  hibaAzonosito() {
    if (!this.hiba.id) {
      this.hiba.id = `kurzus-hiba-${Math.random().toString(36).slice(2, 9)}`;
    }
    return this.hiba.id;
  }
}

if (!customElements.get('kurzus-vasarlas')) {
  customElements.define('kurzus-vasarlas', KurzusVasarlas);
}